import React, { Component } from 'react'
import TeamCard from './cards/team'
import Fade from 'react-reveal/Fade'

class TeamBlock extends Component {

  render() {

    let { members, count } = this.props

    return (
      <section className='team-block'>
        <div className='team-block__inner'>
          <div className='team-block__content'>
            <div className='team-block__menu'>    
              <Fade cascade bottom distance='40px' duration={1000}>
              <ul>
                <li><span>We found</span> {count} Results</li>
              </ul>
              </Fade>
            </div>
            { members && 
              <div className='team-block__members'> 

                {members.map((el, i) => (
                  <Fade bottom distance='40px' duration={1000} key={i}>
                    <div className='team-block__member'> 
                      <TeamCard {...el} />
                    </div>
                  </Fade>
                ))}

              </div>
            }
          </div>
        </div>
      </section>
    )
  }
}

export default TeamBlock
